import { ICustomRouteConfig } from "@/store/interface/custom.route.config.interface";
import { RouteConfig } from "vue-router";

/**
 * Copies the `permission` property from ICustomRouteConfig into `meta.permission`
 * so that it is available in navigation guards via `to.meta.permission`.
 *
 * Vue Router 3 does not propagate custom RouteConfig properties to `to.meta`,
 * only the `meta` field is preserved. This function bridges that gap.
 *
 * Mutates routes in-place and handles children recursively.
 */
export function enrichRouteMeta(routes: ICustomRouteConfig[]): RouteConfig[] {
  for (const route of routes) {
    const permission = route.permission;

    if (permission) {
      if (!route.meta) {
        route.meta = {};
      }
      route.meta.permission = permission;
    }

    if (route.children) {
      enrichRouteMeta(route.children);
    }
  }

  return routes;
}
